import React from 'react';
import { useAuth } from '~/contexts/AuthContext'; // Or wherever auth state is stored

// Example usage:
// <PermissionGuard require="Permissions.Dashboard.View">
//   <DashboardComponent />
// </PermissionGuard>

const PermissionGuard = ({ children, require, fallback = null }) => {
    // Assuming auth context provides user object with Role and Permissions array
    // You may need to adapt this to match your actual AuthContext structure
    const { user, admin } = useAuth() || { user: null, admin: null };

    const currentUser = admin || user;

    if (!currentUser) return fallback;

    // Super Admin bypass
    const roles = currentUser.Roles || currentUser.roles || [];
    const roleString = currentUser.Role || currentUser.role;

    if (
        roleString === 'Super Admin' || 
        (Array.isArray(roles) && roles.includes('Super Admin'))
    ) {
        return <>{children}</>;
    }

    // Check permissions
    const permissions = currentUser.Permissions || currentUser.permissions || [];
    const hasPermission = Array.isArray(require) 
        ? require.some(p => permissions.includes(p))
        : permissions.includes(require);

    if (hasPermission) {
        return <>{children}</>;
    }

    return fallback;
};

export default PermissionGuard;
